<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Compose Mail" pageTitle="Compose Mail" />
            <ComposeMail />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ComposeMail from '../ComposeMail/ComposeMail'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ComposeMailPage',
    components: {
        MainHeader,
        PageTitle,
        ComposeMail,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>